import React from 'react';
import BaseModal from '../common/BaseModal';

/**
 * Okno po restarcie strony kasy w trakcie druku paragonu.
 *
 * Czysto prezentacyjne: dostaje wpis "druku w toku" (drukWToku.js) i trzy
 * decyzje kasjera. NIE zmienia statusu samo - to robi useDrukPrzerwany.
 * Nigdy nie ustawia fiskalizacji automatycznie: kazdy przycisk to swiadoma
 * odpowiedz czlowieka, ktory widzi (albo nie widzi) paragon na rolce.
 *
 * Trzy odpowiedzi:
 *   "Tak, wydrukowal sie"  -> fiskalizacja = 1  (paragon jest, nie drukowac ponownie)
 *   "Nie, nie wyszedl"     -> fiskalizacja = -1 (na liscie "Ponow fiskalizacje")
 *   "Nie wiem, sprawdze"   -> nic; okno wroci przy nastepnym starcie POS
 */

const kwotaTekst = (kwota) => {
  const n = parseFloat(kwota);
  if (!Number.isFinite(n)) return null;
  return `${n.toFixed(2).replace('.', ',')} zł`;
};

const czasTekst = (iso) => {
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return null;
  return d.toLocaleString('pl-PL', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' });
};

const przycisk = (kolor, pelny) => ({
  padding: '6px 12px',
  fontSize: '12px',
  fontWeight: 500,
  border: `2px solid ${kolor}`,
  backgroundColor: pelny ? kolor : 'var(--card-bg)',
  color: pelny ? '#fff' : kolor,
  cursor: 'pointer',
  borderRadius: '4px',
  whiteSpace: 'nowrap',
});

const DrukPrzerwanyModal = ({ wpis, zajety = false, onTak, onNie, onNieWiem }) => {
  if (!wpis) return null;

  const numer = wpis.numer || `#${wpis.transactionId}`;
  const kwota = kwotaTekst(wpis.kwota);
  const kiedy = czasTekst(wpis.rozpoczeto);
  const ponowny = wpis.sciezka === 'ponowny';

  const footer = (
    <div style={{ display: 'flex', gap: '0.5rem', width: '100%', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
      <button type="button" onClick={onNieWiem} disabled={zajety} style={przycisk('var(--text-muted)', false)}>
        Nie wiem, sprawdzę
      </button>
      <button type="button" onClick={onNie} disabled={zajety} style={przycisk('var(--danger)', false)}>
        Nie, nie wyszedł
      </button>
      <button type="button" onClick={onTak} disabled={zajety} style={przycisk('var(--success)', true)}>
        Tak, wydrukował się
      </button>
    </div>
  );

  return (
    <BaseModal
      isOpen
      onClose={onNieWiem}
      title="Paragon był w trakcie druku"
      headerIcon="🖨️"
      subtitle="Strona kasy została zrestartowana, zanim drukarka potwierdziła wydruk"
      size="sm"
      zIndex={1060}
      footer={footer}
    >
      <p style={{ margin: '0 0 0.75rem 0', fontSize: '12px', lineHeight: 1.5 }}>
        Paragon <strong>{numer}</strong>{kwota ? <> ({kwota})</> : null} był w trakcie druku
        {ponowny ? ' (ponowna fiskalizacja z listy)' : ''}, gdy strona kasy została zrestartowana
        {kiedy ? <> o <strong>{kiedy}</strong></> : null}.
      </p>
      <p style={{ margin: '0 0 0.75rem 0', fontSize: '12px', fontWeight: 600 }}>
        Czy wyszedł z drukarki?
      </p>
      <p style={{ margin: 0, fontSize: '11px', color: 'var(--text-muted)', lineHeight: 1.5 }}>
        Sprawdź rolkę. „Tak” oznaczy paragon jako zafiskalizowany (bez ponownego druku).
        „Nie” oznaczy go jako niewydrukowany – na liście transakcji będzie „Ponów fiskalizację”.
        „Nie wiem” niczego nie zmienia; to pytanie wróci przy następnym uruchomieniu kasy.
      </p>
    </BaseModal>
  );
};

export default DrukPrzerwanyModal;
